import { ExclamationCircleOutlined } from '@ant-design/icons'
import { css } from '@emotion/react'
import React from 'react'
import { Text } from 'src/components/nativeCompat/Text'
import { View } from 'src/components/nativeCompat/View'
import { Disable } from 'src/features/theme/KdsThemeColor'

const styles = {
  container: css`
    flex-direction: row;
    align-items: center;
    margin-top: 8px;
    gap: 4px;
  `,
}

export const NoMasterDataMessage: React.FC = () => {
  return (
    <View css={styles.container}>
      <ExclamationCircleOutlined style={{ color: Disable, fontSize: 14 }} />
      <Text style={{ color: Disable }}>
        この製品では、管理者の設定により回答は不要です
      </Text>
    </View>
  )
}
